// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__c0za-","search_icon":"Search_search_icon__Jlz4j","clear_value":"Search_clear_value__3MQXq"};